// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__15Pky","insightsList":"newBusinessInsightsMenu_insightsList__3e6ZI","active":"newBusinessInsightsMenu_active__1lMzp"};